// src/utils/auth.js

import {getAuth} from "firebase/auth";
import appFirebase from "../firebase";

export const saveJwtToken = (token) => {
    localStorage.setItem('jwtToken', token);
};

const auth = getAuth(appFirebase);


export const getJwtToken = async () => {
    let token = localStorage.getItem('jwtToken')!== null ? localStorage.getItem('jwtToken') : null;

    if (token) {
        const decodedToken = decodeJwt(token);
        const currentTime = Date.now() / 1000; // Tiempo actual en segundos

        if (decodedToken.exp < currentTime) {
            // El token ha expirado, intentamos obtener uno nuevo desde Firebase
            token = await refreshToken(); // Llamada a Firebase para obtener un nuevo token
            if (token) {
                saveJwtToken(token); // Guardamos el nuevo token
            } else {
                removeJwtToken(); // Si no se obtuvo un nuevo token, eliminamos el anterior
            }
        }
    }

    return token; // Retorna el token si no expiró, o el nuevo token si fue refrescado
};

const decodeJwt = (token) => {
    const payload = token.split('.')[1];
    return JSON.parse(atob(payload));
};

// Función para refrescar el token utilizando Firebase Authentication
const refreshToken = async () => {
    try {
        const user = auth.currentUser;
        if (user) {
            // Refrescar el token de acceso a Firebase
            return await user.getIdToken(true); // Retorna el nuevo token
        }
        return null; // Si no hay usuario autenticado, retorna null
    } catch (error) {
        console.error('Error refreshing token:', error);
        return null;
    }
};

export const removeJwtToken = () => {
    localStorage.removeItem('jwtToken');
};

export const saveUserData = (userData) => {
    localStorage.setItem('userData', JSON.stringify(userData));
};

export const getUserData = () => {
    return localStorage.getItem('userData') !== null ? JSON.parse(localStorage.getItem('userData')) : null;
};

export const removeUserData = () => {
    localStorage.removeItem('userData');
};

export const gLogin = () => {
    return localStorage.getItem('gLogin') !== null ? JSON.parse(localStorage.getItem('gLogin')) : null;
}

export const setgLogin = (gLogin) => {
    localStorage.setItem('gLogin', JSON.stringify(gLogin));
}

export const removegLogin = () => {
    localStorage.removeItem('gLogin');
}